import { Component, OnInit } from '@angular/core';
import { FillerService } from '../../common/Service_tnFiller';
import {Router, ActivatedRoute, Params} from '@angular/router';
import * as myGlobals from '../../global';
import * as myLanguages from '../../common/vars_translate';

@Component({
  selector: 'tn-news-list',
  templateUrl: '../../themes/default/html/tnnewslist.component.html',
  styleUrls: ['../../themes/default/css/tnnewslist.component.scss']
})
export class TnnewslistComponent implements OnInit {

	NewsList: any = [];
	imagesurl: any = myGlobals.apiBasePath;
	HomeAd: any;

	constructor(private filler: FillerService, private activatedRoute: ActivatedRoute) {
		this.HomeAd = Object.assign([],myLanguages.translations_IT.HomeAd);
	}

	ngOnInit() {
		this.UpdateFiller();
	}

	UpdateFiller() {
		var payload = JSON.stringify({id: 0, categoryId: 0, homeVisible: "true", offset: 0, limit: 3, uiCulture: "it"});
		new Promise((resolve, reject) => {
		this.filler.Get_News_List(payload).subscribe(
			data => {
				this.NewsList = Object.assign(this.NewsList, data.Items)
				resolve(true);
			}, err => { console.log(err) });
		}).then(
			e => console.log('')
		);
		
	}

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnnewslist/tnnewslist.component.ts